import { AxiosRequestConfig } from 'axios'

export interface PushNotificationsParams {
  startDate?: string
  endDate: string
  onlyWithBenefits?: boolean
}

export interface FunnelData {
  sent: number
  received: number
  walkthrough: number
  ctr: number
  conversions: number
  sentPct: string
  receivedPct: string
  walkthroughPct: string
  ctrPct: string
  conversionsPct: string
}

export interface PushNotificationsData {
  campaignPushes: number
  automatedPushes: number
  sent: number
  received: number
  walkthrough: number
  ctr: number
  conversions: number
  generalConversionRate: number
  manualConversionRate: number
  automationConversionRate: number
  manualCampaignsCount: number
  automatedCampaignsCount: number
  tableData: {
    sent: number
    received: number
    walkthrough: number
    ctr: number
    conversions: number
    sentPct: string
    receivedPct: string
    walkthroughPct: string
    ctrPct: string
    conversionsPct: string
  }
  barData: {
    name: string
    value: number
  }[]
  manualFunnel: FunnelData
  automatedFunnel: FunnelData
}

export interface PushNotificationsResponse {
  data: PushNotificationsData
}

const getPushNotifications = (params: PushNotificationsParams): AxiosRequestConfig => ({
  url: '/dashboard/push-notifications',
  method: 'GET',
  params,
})

export { getPushNotifications }
